'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

exports['default'] = function (name) {
	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		args[_key - 1] = arguments[_key];
	}

	if (args.length === 0) {
		return name;
	}

	var key = name;

	args.forEach(function (arg) {
		if (Object(arg) === arg) {
			key += '#' + Object.keys(arg).map(function (k) {
				return JSON.stringify(arg[k]).replace(/"/gi, '');
			}).join('#');
		} else {
			key += '#' + String(arg);
		}
	});

	return key;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/cache-key.js
// module id = 4kel
// module chunks = 15